export const reportStatusClasses = {
  status: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px 12px 0px',
    gap: '10px',
    width: 'auto',
    maxWidth: '350px',
    height: '26px',
    background: 'var(--color-neutral-300)',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-md)',
    fontSize: '12px'
  },
  inProgress: {
    background: 'var(--color-primary-100)',
    color: 'var(--color-contrast-primary-200)',
    borderColor: 'var(--color-primary-400)'
  },
  success: {
    backgroundColor: 'var(--color-success-200)',
    color: 'var(----color-contrast-success-200)',
    borderColor: 'var(--color-success-400)'
  },
  warning: {
    backgroundColor: 'var(--color-warning-200)',
    color: 'var(----color-contrast-warning-200)',
    borderColor: 'var(--color-warning-400)'
  },
  shared: {
    backgroundColor: 'var(--color-neutral-200)',
    color: 'var(----color-contrast-neutral-200)',
    borderColor: 'var(--color-neutral-400)'
  }
}
